import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subject } from 'rxjs';

export class LoadingInfo {
  loading: boolean;
  loadingMsg: string;
  showCancelButton: boolean;
  constructor(
    loading?: boolean,
    loadingMsg?: string,
    showCancelButton?: boolean
  ) {
    this.loading = loading;
    this.loadingMsg = loadingMsg;
    this.showCancelButton = showCancelButton;
  }
}

@Injectable()
export class WaitLoadingService implements OnDestroy {
  private escapeEvent = new Subject<void>();
  private loadingEvent = new Subject<LoadingInfo>();

  private loadingObs: Observable<LoadingInfo>;
  private escapeObs: Observable<void>;

  constructor() {
    this.loadingObs = this.loadingEvent.asObservable();
    this.escapeObs = this.escapeEvent.asObservable();
  }

  public getEscapeObservable(): Observable<void> {
    return this.escapeEvent;
  }

  public getLoadingObservable(): Observable<LoadingInfo> {
    return this.loadingObs;
  }

  public cancelWaiting(message = ''): void {
    this.setLoadingInfo(new LoadingInfo(false, message));
  }

  public startWaiting(message = ''): void {
    this.setLoadingInfo(new LoadingInfo(true, message));
  }

  public setLoadingInfo(loadingInfo: LoadingInfo): void {
    this.loadingEvent.next(loadingInfo);
  }

  public escapePressesd(): void {
    this.escapeEvent.next();
  }

  ngOnDestroy(): void {
    this.escapeEvent.unsubscribe();
    this.loadingEvent.unsubscribe();
  }

}
